/*
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import QS from 'qs'
import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'


// 环境的切换
// axios.defaults.baseURL = 'http://114.55.25.119:9999/'

// if (process.env.NODE_ENV == 'development') {
//   axios.defaults.baseURL = '/api';
// } else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = '';
// } else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'http://api.123dailu.com/';
// }

// 请求超时时间
axios.defaults.timeout = 50000

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token;
    // token && (config.headers.Authorization = token);
    if (localStorage.getItem("ship_token")) {
      config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("ship_token")
    }
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if(response.data.code && response.data.code !== 0){
        Message({
          showClose: false,
          message: response.data.msg || '网络请求失败，请稍后重试',
          duration: 1500,
          type: 'warning'
        });
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 401:
          localStorage.removeItem('ship_token');
          localStorage.removeItem('ship_user');
          router.push({name : 'login'});
          Message({
            showClose: false,
            message: '登录状态已过期，请重新登录',
            duration: 1500,
            type: 'warning'
          });
          break
        // 其他错误，直接抛出错误提示
        default:

      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function axiosGet (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function axiosPost (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url + '?' + QS.stringify(params), params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function axiosPut (url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url + '?' + QS.stringify(params), params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * delete方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function axiosDelete (url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url + '?' + QS.stringify(params), params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/require.js